export default {
      id: "yogurt-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "img/icons.svg#yogurt",
      toString: function () {
        return this.url;
      }
    }